export default "__VITE_ASSET__CCTL7$sq__"